import React from 'react';
import { Box, Paper, TextField } from '@material-ui/core';

const formatUpdatedAt = (value) => {
  if (!value) return '';

  const date = new Date(value);

  if (!Number.isNaN(date.getTime())) {
    return date.toISOString().slice(0, 10);
  }

  return String(value);
};

const formatLocale = (value) => {
  if (!value) return '';
  return String(value).replace('_', '-');
};

const MyAccount = ({ userInfo }) => {
  if (!userInfo) {
    return null;
  }

  const fields = [
    {
      label: 'Nom',
      value: userInfo?.family_name || '',
    },
    {
      label: 'Prénom',
      value: userInfo?.given_name || '',
    },
    {
      label: 'Nom complet',
      value: userInfo?.name || '',
    },
    {
      label: 'Adresse mail',
      value: userInfo?.preferred_username || userInfo?.email || '',
    },
    {
      label: 'Identifiant',
      value: userInfo?.sub || '',
    },
    {
      label: 'Locale',
      value: formatLocale(userInfo?.locale),
    },
    {
      label: 'Zone',
      value: userInfo?.zoneinfo || '',
    },
    {
      label: 'Groupes',
      value: (userInfo?.groups || []).length ? userInfo.groups.join(', ') : 'Aucun groupe',
    },
    {
      label: 'Date dernière mise à jour',
      value: formatUpdatedAt(userInfo?.updated_at),
    },
  ];

  return (
    <Box p={2}>
      <Paper
        elevation={0}
        style={{
          padding: 0,
          background: 'transparent',
          boxShadow: 'none',
        }}
      >
        <Box display="flex" flexDirection="column" gridGap={22}>
          {fields.map((field) => (
            <TextField
              key={field.label}
              label={field.label}
              value={field.value}
              variant="outlined"
              fullWidth
              disabled
              InputProps={{
                readOnly: true,
              }}
            />
          ))}
        </Box>
      </Paper>
    </Box>
  );
};

export default MyAccount;
